import { format } from 'date-fns';
import { DashboardForm } from 'types/dashboard';

export const getDisplayLabel = (
    option: { value: string; label: string },
    selectedTimeRange: DashboardForm['selectedTimeRange'],
    dateFrom: string,
    dateTo: string,
    dateFormat: string
) => {
    if (option.value === 'custom' && selectedTimeRange?.value === 'custom' && dateFrom && dateTo) {
        return `${format(new Date(dateFrom), dateFormat)}–${format(new Date(dateTo), dateFormat)}`;
    }
    return option.label;
};

/**
 * The inset both hours-card tabs keep from the panel's top and sides. Each tab mounts the shared period picker in
 * its own top-right corner, so one inset is what keeps the picker in the same box across a tab switch.
 */
export const PANEL_INSET = 'px-4 pt-4';
